import React from 'react';
import { format } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { formatAmountToFixed } from 'src/utils/utils';
import { RootState } from 'src/configs/store';
import './TillHistoryTable.scss';
import classNames from 'classnames';

interface TransactionProps {
  transactions: any,
  isAdmin: string
}

function TillHistoryTable({ transactions, isAdmin }: TransactionProps) {
  const { t } = useTranslation();
  const { selectedTimezone } = useSelector((state: RootState) => state.odds);

  return (
    <div className="till-table">
      <div className="till-table__head">
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.id') }</span>
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.date') }</span>
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.code') }</span>
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.description') }</span>
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.amount') }</span>
        <span className={
          classNames({
            'till-table__title':true,
            'till-table__title--right': isAdmin
          })
        }
        >{ t('transactions.user') }</span>

      </div>
      <div className="till-table__body">
        {
          transactions && transactions.length > 0 &&
          _.map(transactions, (transaction) => {
            const divisor = transaction?.wallet?.divisor || 100;
            const date = format(transaction.createdAt &&
               utcToZonedTime(transaction.createdAt * 1000, selectedTimezone), 'dd/MM/yyyy HH:mm');
            return (
              <div key={ transaction.id } className="till-table__cell-group">
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ transaction.id }</span>
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ date }</span>
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ transaction.transactionType.code }</span>
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ transaction.description }</span>
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ formatAmountToFixed(transaction.amount, divisor) }</span>
                <span className={
                  classNames({
                    'till-table__cell': true,
                    'till-table__cell--right': isAdmin
                  })
                }
                >{ `${ transaction.user.id } - ${ transaction.user.username }` }</span>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}

export default TillHistoryTable;
